import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(username, password);
      toast.success('登入成功');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || '登入失敗，請檢查用戶名和密碼');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cyan-50 to-teal-50" data-testid="admin-login-page">
      <div className="glass max-w-md w-full p-8 rounded-3xl">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-4">
            <LogIn className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold gradient-text mb-2">管理員登入</h1>
          <p className="text-slate-600">樹記海鮮 CMS 系統</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6" data-testid="login-form">
          <div>
            <label className="block text-sm font-medium mb-2">用戶名</label>
            <Input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full rounded-xl border-primary/30"
              placeholder="輸入用戶名"
              required
              data-testid="username-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">密碼</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border-primary/30"
              placeholder="輸入密碼"
              required
              data-testid="password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-gradient-to-r from-primary to-secondary hover:opacity-90 py-6 text-lg"
            data-testid="login-submit-btn"
          >
            {loading ? '登入中...' : '登入'}
          </Button>
        </form>

        <p className="text-center text-sm text-slate-500 mt-6">
          首次使用？請聯絡管理員創建帳號
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;